export default "__VITE_ASSET__MCDxqMZG__"